import * as React from 'react';
import { Datagrid, List, TextField, useRecordContext } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { IndexField } from '../../components/IndexField';
import { ListActions } from '../../components/ListAction';
import { ListIsEmptyPage } from '../../components/ListIsEmptyPage';

const ColorSwatch = (props: { source: string }) => {
  const record = useRecordContext();
  const color = record?.[props.source];
  if (!color) return null;
  return <div style={{ width: 20, height: 20, borderRadius: 4, border: '1px solid #ccc', backgroundColor: color }} />;
};

export const TagsList = (props: object) => (
  <List sort={{ field: 'title', order: 'ASC' }} empty={<ListIsEmptyPage />} actions={<ListActions />} title={<CustomTitle />} {...props}>
    <Datagrid rowClick="edit">
      <IndexField label="#" sortable={false} />
      <TextField source="title" />
      <ColorSwatch source="bgColor" />
      <ColorSwatch source="fgColor" />
      <TextField source="id" />
    </Datagrid>
  </List>
);
